import { render } from "./VisualizacaoLogJobs.vue?vue&type=template&id=61fd916a&scoped=true"
import script from "./VisualizacaoLogJobs.vue?vue&type=script&lang=js"
export * from "./VisualizacaoLogJobs.vue?vue&type=script&lang=js"

import "./VisualizacaoLogJobs.vue?vue&type=style&index=0&id=61fd916a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fd916a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTimeline,QTimelineEntry});
